__turbopack_context__.v({
  "image": "AO_PvG_image",
  "link": "AO_PvG_link",
});
